<panel width="600">
	<h1>{{ 'product.variants' | translate }}</h1>
	@if (!variantLists) {
		<skeletons width="100" [defaultSkeletons]="8" />
	}
	@else {
		<list-view scrollable>
			<header defaultSorting="ascending">{{ 'product.variants.variant-option-name' | translate }}</header>
			<row *listData="let option from variantListOptions" [groupBy]="getListName(option)" (groupHeaderAction)="toggleAll(option.variantList)" [clickable]="false">
				<column><custom-input [label]="option.name" [inputType]="inputType.Checkbox" [value]="isSelected(option)" (valueChange)="toggle(option, $event)" /></column>
			</row>
		</list-view>
		@if (showSaveButton) {
			<button confirm (click)="saveSelectedVariants()" [label]="'product.variants.save-new-variants' | translate"></button>
		}
	}
</panel>
